/* src/app/admin-dashboard/announcement/announcement-list.component.css */
.card {
  margin-bottom: 1rem;
}
/*# sourceMappingURL=announcement-list.component.css.map */
